import { makeEnvironmentProviders } from '@angular/core';
import { provideQuillConfig } from 'ngx-quill/config';

export const provideQuillEditorDefaults = () =>
  makeEnvironmentProviders([
    provideQuillConfig({
      theme: 'bubble',
      sanitize: true,
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          ['clean'],
        ],
      },
      formats: [
        'bold',
        'italic',
        'underline',
        'strike',
        'header',
        'list',
        'script',
        'indent',
        'direction',
      ],
    }),
  ]);
